// extracted by mini-css-extract-plugin
export default {"pieChart":"m80uB__pieChart"};